var newSezzleData = document.querySelector(`.section--main-product [id^="ProductSezzle-"]`).dataset;
var renderSezzle = new AwesomeSezzle({
    amount: newSezzleData.price
});
renderSezzle.init();

let sezzleInitialized = false;
renderSezzle.getElementToRender().querySelector('[aria-haspopup="dialog"]').addEventListener("click", function () {
    const modal = document.querySelector('.sezzle-modal');
    trapFocus(modal, { autofocus: false });

    if (sezzleInitialized) return;
    sezzleInitialized = true;
    modal.addEventListener('keyup', function (event) {
        if (event.key === 'Escape') {
            renderSezzle.getElementToRender().focus();
        }
    });
});

